import { AspectRatio } from '@mantine/core';

export function Embed({ item }) {
  return (
    <AspectRatio ratio={16 / 9}>
      <iframe
        src={item.src}
        sandbox="allow-scripts allow-popups allow-top-navigation-by-user-activation allow-forms allow-same-origin allow-storage-access-by-user-activation allow-popups-to-escape-sandbox"
        allowFullScreen
        title="Embed"
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '1px',
          pointerEvents: 'auto',
          backgroundColor: 'rgb(25, 25, 25)',
        }}
      />
    </AspectRatio>
  );
}
